<div class="filter-sidenav-container">
    <div class="filter-header">
        <div class="header-title-group">
            <h2>{{ 'permit.manage.filters.title' | translate }}</h2>
            <span class="filter-count-badge" *ngIf="activeFilterCount > 0">{{ activeFilterCount }}</span>
        </div>
        <div class="header-actions-group">
            <button mat-icon-button
                    class="save-filter-btn"
                    *ngIf="activeFilterCount > 0"
                    (click)="startSave()"
                    [matTooltip]="'permit.manage.filters.save_filter' | translate">
                <mat-icon>bookmark_border</mat-icon>
            </button>
            <button class="reset-button" mat-flat-button color="primary" *ngIf="activeFilterCount > 0" (click)="reset()">
                {{ 'permit.manage.filters.reset' | translate }}
            </button>
        </div>
    </div>

    <!-- Saved Filters Accordion -->
    <div class="saved-filters-section" *ngIf="savedFilters.length > 0 || isSaving">
        <div class="saved-filters-header" (click)="toggleAccordion()">
            <span class="saved-filters-title">
                {{ 'permit.manage.filters.saved_filters' | translate }}
                <span class="saved-filters-count" *ngIf="savedFilters.length > 0">({{ savedFilters.length }})</span>
            </span>
            <mat-icon class="accordion-icon" [class.open]="isAccordionOpen">expand_more</mat-icon>
        </div>

        <div class="saved-filters-body" *ngIf="isAccordionOpen">
            <div class="saved-filter-item" *ngFor="let sf of savedFilters" (click)="onLoadFilter(sf)">
                <span class="saved-filter-name">{{ sf.name }}</span>
                <button mat-icon-button class="delete-filter-btn" (click)="onDeleteFilter(sf.id, $event)">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div class="save-filter-input-row" *ngIf="isSaving">
                <input matInput
                       [formControl]="filterNameControl"
                       [placeholder]="'permit.manage.filters.filter_name_placeholder' | translate"
                       (keyup.enter)="confirmSave()"
                       (keyup.escape)="cancelSave()"
                       class="filter-name-input"
                       #filterNameInput>
                <button mat-icon-button (click)="confirmSave()" [disabled]="!filterNameControl.value?.trim()">
                    <mat-icon>check</mat-icon>
                </button>
                <button mat-icon-button (click)="cancelSave()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <div class="filter-content" [formGroup]="filterForm">

        <!-- Status -->
        <div class="filter-section">
            <div class="section-header">
                <h3>{{ 'permit.manage.filters.status' | translate }}</h3>
                <button mat-button color="primary" class="clear-btn" *ngIf="filterForm.get('status').value" (click)="clearField('status')">
                    <mat-icon>close</mat-icon> {{ 'permit.manage.filters.clear_filters' | translate }}
                </button>
            </div>
            <mat-form-field appearance="outline" class="full-width">
                <mat-select formControlName="status">
                    <mat-option [value]="null">{{ 'permit.manage.filters.all' | translate }}</mat-option>
                    <mat-option *ngFor="let s of statuses" [value]="s._id">
                        {{ resolveI18n(s.name) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-divider></mat-divider>

        <!-- Category -->
        <div class="filter-section">
            <div class="section-header">
                <h3>{{ 'permit.manage.filters.category' | translate }}</h3>
                <button mat-button color="primary" class="clear-btn" *ngIf="filterForm.get('category').value" (click)="clearField('category')">
                    <mat-icon>close</mat-icon> {{ 'permit.manage.filters.clear_filters' | translate }}
                </button>
            </div>
            <mat-form-field appearance="outline" class="full-width">
                <mat-select formControlName="category">
                    <mat-option [value]="null">{{ 'permit.manage.filters.all' | translate }}</mat-option>
                    <mat-option *ngFor="let cat of categories" [value]="cat._id">
                        {{ resolveI18n(cat.name) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-divider></mat-divider>

        <!-- Permit Type (dependent on category) -->
        <div class="filter-section">
            <div class="section-header">
                <h3>{{ 'permit.manage.filters.permit_type' | translate }}</h3>
                <button mat-button color="primary" class="clear-btn" *ngIf="filterForm.get('permitType').value" (click)="clearField('permitType')">
                    <mat-icon>close</mat-icon> {{ 'permit.manage.filters.clear_filters' | translate }}
                </button>
            </div>
            <mat-form-field appearance="outline" class="full-width">
                <mat-select formControlName="permitType">
                    <mat-option [value]="null">{{ 'permit.manage.filters.all' | translate }}</mat-option>
                    <mat-option *ngFor="let pt of permitTypes" [value]="pt._id">
                        {{ resolveI18n(pt.name) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-divider></mat-divider>

        <!-- Department -->
        <div class="filter-section">
            <div class="section-header">
                <h3>{{ 'permit.manage.filters.department' | translate }}</h3>
                <button mat-button color="primary" class="clear-btn" *ngIf="filterForm.get('department').value" (click)="clearField('department')">
                    <mat-icon>close</mat-icon> {{ 'permit.manage.filters.clear_filters' | translate }}
                </button>
            </div>
            <mat-form-field appearance="outline" class="full-width">
                <mat-select formControlName="department">
                    <mat-option [value]="null">{{ 'permit.manage.filters.all' | translate }}</mat-option>
                    <mat-option *ngFor="let dept of departments" [value]="dept._id">
                        {{ departmentLabel(dept) }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-divider></mat-divider>

        <!-- Assigned To -->
        <div class="filter-section">
            <div class="section-header">
                <h3>{{ 'permit.manage.filters.assigned_to' | translate }}</h3>
                <button mat-button color="primary" class="clear-btn" *ngIf="filterForm.get('assignedTo').value" (click)="clearField('assignedTo')">
                    <mat-icon>close</mat-icon> {{ 'permit.manage.filters.clear_filters' | translate }}
                </button>
            </div>
            <app-search-dropdown
                [mode]="'single'"
                [showRadio]="false"
                (usersSelected)="filterForm.get('assignedTo').setValue($event[0]?.id || null)">
            </app-search-dropdown>
        </div>

        <mat-divider></mat-divider>

        <!-- Date From / Date To -->
        <div class="filter-section">
            <div class="section-header">
                <h3>{{ 'permit.manage.filters.date_from' | translate }} / {{ 'permit.manage.filters.date_to' | translate }}</h3>
                <button mat-button color="primary" class="clear-btn"
                    *ngIf="filterForm.get('dateFrom').value || filterForm.get('dateTo').value"
                    (click)="clearField('dateFrom'); clearField('dateTo')">
                    <mat-icon>close</mat-icon> {{ 'permit.manage.filters.clear_filters' | translate }}
                </button>
            </div>
            <mat-form-field appearance="outline" class="full-width date-field">
                <mat-date-range-input [rangePicker]="dateRangePicker" [max]="maxDate">
                    <input matStartDate formControlName="dateFrom"
                           [placeholder]="'permit.manage.filters.date_from' | translate">
                    <input matEndDate formControlName="dateTo"
                           [placeholder]="'permit.manage.filters.date_to' | translate">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #dateRangePicker [panelClass]="'montserrat-datepicker'"></mat-date-range-picker>
            </mat-form-field>
        </div>

        <mat-divider></mat-divider>

        <!-- Tags -->
        <div class="filter-section">
            <div class="section-header">
                <h3>{{ 'permit.manage.filters.tags' | translate }}</h3>
                <button mat-button color="primary" class="clear-btn" *ngIf="selectedTags.length > 0" (click)="clearField('tags')">
                    <mat-icon>close</mat-icon> {{ 'permit.manage.filters.clear_filters' | translate }}
                </button>
            </div>
            <mat-chip-list #tagChipList>
                <input
                    [placeholder]="'permit.manage.filters.tags_placeholder' | translate"
                    [formControl]="tagInputCtrl"
                    [matChipInputFor]="tagChipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
                    (matChipInputTokenEnd)="onTagInputTokenEnd($event)"
                    [matAutocomplete]="tagAuto"
                />
                <mat-chip
                    *ngFor="let tag of selectedTags"
                    [removable]="true"
                    (removed)="removeTag(tag)">
                    {{ tag }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
            <mat-autocomplete #tagAuto="matAutocomplete" (optionSelected)="onTagSuggestionSelected($event)">
                <mat-option *ngFor="let tag of tagSuggestions" [value]="tag">{{ tag }}</mat-option>
            </mat-autocomplete>
        </div>

        <mat-divider></mat-divider>

        <!-- Sync Status -->
        <div class="filter-section">
            <div class="section-header">
                <h3>{{ 'permit.manage.filters.sync_status' | translate }}</h3>
                <button mat-button color="primary" class="clear-btn" *ngIf="filterForm.get('syncStatus').value" (click)="clearField('syncStatus')">
                    <mat-icon>close</mat-icon> {{ 'permit.manage.filters.clear_filters' | translate }}
                </button>
            </div>
            <mat-form-field appearance="outline" class="full-width">
                <mat-select formControlName="syncStatus">
                    <mat-option [value]="null">{{ 'permit.manage.filters.all' | translate }}</mat-option>
                    <mat-option *ngFor="let opt of syncStatusOptions" [value]="opt.value">
                        {{ opt.labelKey | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <mat-divider></mat-divider>

    </div>
</div>
